"use strict";
// Copyright 2022 Fewcha. All rights reserved.
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Web3Provider = exports.utils = exports.Aptos = void 0;
const Aptos = __importStar(require("aptos"));
exports.Aptos = Aptos;
const utils = __importStar(require("./utils"));
exports.utils = utils;
const provider_1 = __importDefault(require("./provider"));
exports.Web3Provider = provider_1.default;
const martina_mask_1 = require("./martina.mask");
class Web3 {
    action;
    constructor(provider) {
        if (provider) {
            if (provider.isFewcha) {
                this.action = new provider_1.default(provider).provider;
            }
            else {
                this.action = new martina_mask_1.MartianMask(provider);
            }
        }
        else {
            this.action = new provider_1.default(window.fewcha).provider;
            window.addEventListener("fewcha#initialized", () => {
                this.action = new provider_1.default(window.fewcha).provider;
            });
            window.addEventListener("martian#initialized", () => {
                this.action = new provider_1.default(window.martian).provider;
            });
        }
        return this;
    }
    setProvider(provider) {
        this.action = provider.provider;
        return this;
    }
}
exports.default = Web3;
